import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ChevronDown } from 'lucide-react';
import type { Volume } from '../data/volumes';
const PREVIEW_COUNT = 8;
interface VolumeCardProps {
  volume: Volume;
  index: number;
}
export function VolumeCard({
  volume,
  index
}: VolumeCardProps) {
  const [expanded, setExpanded] = useState(false);
  const visibleBullets = expanded ? volume.bullets : volume.bullets.slice(0, PREVIEW_COUNT);
  const hiddenCount = volume.bullets.length - PREVIEW_COUNT;
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.3,
    delay: index % 2 * 0.05,
    ease: [0.23, 1, 0.32, 1]
  }} className={`bg-card rounded-2xl border ${volume.popular ? 'border-gold' : 'border-line'} p-8 relative overflow-hidden flex flex-col h-full shadow-[0_18px_40px_-28px_rgba(0,0,0,0.9)]`} data-id="element-326" data-mp="1pvcv1sr55fum">
      {volume.popular && <div className="absolute top-6 right-[-35px] bg-gold text-canvas font-bold text-xs py-1 px-10 rotate-45" data-id="element-327" data-mp="37caecnsf8z29">
          START HERE
        </div>}
      <div className="mb-5 pr-16" data-id="element-328" data-mp="3cak60oexthj4">
        <div className="text-gold font-display font-semibold text-sm uppercase tracking-widest" data-id="element-329" data-mp="2xm7a1rfunyom">
          {volume.number}
        </div>
        <h3 className="text-2xl font-display font-bold leading-tight mt-1 text-white" data-id="element-330" data-mp="32k8uogsxc627">
          {volume.title}
        </h3>
      </div>
      <p className="text-white font-medium mb-5 border-l-2 border-gold pl-4" data-id="element-331" data-mp="2onlwkap8j9up">{volume.subtitle}</p>
      <p className="text-mist text-sm leading-relaxed mb-6" data-id="element-332" data-mp="2tij2h8r7x33d">{volume.problem}</p>

      <h4 className="text-xs font-bold text-steel uppercase tracking-widest mb-3" data-id="element-333" data-mp="2eowbk921l9a8">Inside</h4>
      <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2 mb-3" data-id="element-334" data-mp="2jn7myo7zjruk">
        {visibleBullets.map(bullet => <li key={bullet} className="flex items-start gap-2" data-id="element-335" data-mp="cwhwdhqvuixi">
            <Check size={15} className="text-gold shrink-0 mt-0.5" aria-hidden="true" data-id="element-336" data-mp="hvbclhxk0o1d" />
            <span className="text-mist text-sm" data-id="element-337" data-mp="gefdsyt1lkb7">{bullet}</span>
          </li>)}
      </ul>
      {hiddenCount > 0 && <button type="button" onClick={() => setExpanded(value => !value)} className="self-start inline-flex items-center gap-1 text-sm font-semibold text-gold hover:text-gold-light transition-colors duration-150 ease-out mb-6 focus-visible:outline-none focus-visible:underline" aria-expanded={expanded} data-id="element-338" data-mp="bdrrurjo7tnu">
          {expanded ? 'Show less' : `Show all ${volume.bullets.length} topics`}
          <ChevronDown size={16} className={`transition-transform duration-200 ease-out ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-339" data-mp="u7dodse23izc" />
        </button>}
      <div className="flex-grow" data-id="element-340" data-mp="lb61o8b39k76" />
      {volume.sessions && <p className="text-sm font-display font-semibold uppercase tracking-wider text-white mb-4" data-id="element-341" data-mp="1hwg3otl7wzqo">
          {volume.sessions}
        </p>}
      <div className="bg-section border border-line rounded-xl p-4" data-id="element-342" data-mp="2vr6cz4agtlk0">
        <span className="text-gold font-display font-semibold block mb-1 tracking-wider uppercase text-sm" data-id="element-343" data-mp="2vszoaww0wtyc">
          Result
        </span>
        <p className="text-white text-sm" data-id="element-344" data-mp="34r37hmjjdemz">{volume.result}</p>
      </div>
    </motion.article>;
}